module.exports = __webpack_public_path__ + "img/youngtae.04cf37b9.png";